import React, { ReactNode, Fragment, useEffect, useState, useCallback } from "react";
import { useAuth } from "../auth/AuthProvider.js";
import { Container } from "../../../packages/ui/Container.js";
import { Menu } from "./Menu.js";
import { useConfiguration } from "../config/ConfigProvider.js";
import { clsx } from "clsx";
import { useWindowSize } from "../../../packages/ui/window-size/useWindowSize.js";
import { MenuIcon } from "../../../icons/MenuIcon.js";
import { CloseMark } from "../../../icons/CloseMark.js";
import { ContainerWidth } from "../../../packages/ui/ContainerWidth.js";

type Props = {
  children: ReactNode;
  title: string;
  containerWidth?: ContainerWidth;
};

/**
 * Renders the main page layout.
 */
export const Layout = ({ children, title, containerWidth = "fixed-wide" }: Props) => {
  const { isLoggedIn } = useAuth();
  const { isCloudOnly } = useConfiguration();

  const windowSize = useWindowSize();

  // Whether the narrow screen user has opened the menu.
  const [isMenuOpened, setMenuOpened] = useState(false);

  const handleClickMenuButton = useCallback(() => {
    setMenuOpened(true);
  }, []);

  const handleClickCloseButton = useCallback(() => {
    setMenuOpened(false);
  }, []);

  useEffect(() => {
    document.title = `${title} - Organizer`;
  }, [title]);

  const isWideScreen = windowSize.width > 800;

  const hasMenu = isCloudOnly ? false : isLoggedIn;
  const isMenuOpen = hasMenu && (isMenuOpened || isWideScreen);

  const pageClasses = clsx("page", {
    "wide": isWideScreen,
    "narrow": !isWideScreen,
    "menu-open": isMenuOpen
  });

  return (
    <Fragment>
      <div className={pageClasses}>
        {hasMenu && (
          <>
            <div className="menu-button" onClick={handleClickMenuButton}>
              <MenuIcon />
            </div>
            <div className="menu">
              <div className="brand">ORGANIZER</div>
              <Menu />
              {!isWideScreen && (
                <div className="close" onClick={handleClickCloseButton}>
                  <CloseMark />
                </div>
              )}
            </div>
          </>
        )}
        <div className="content">
          <Container width={containerWidth}>{children}</Container>
        </div>
      </div>
    </Fragment>
  );
};
